import { isStyledComponent } from 'styled-components';

export function isType<T, R extends T>(
  value: T,
  verify: Verify<R>,
): value is R {
  return verify(value as R);
}

interface Verify<T> {
  (value: T): boolean;
}

export const createIsType = <T, R extends T>(verify: Verify<R>) =>
  function(value: T): value is R {
    return isType<T, R>(value, verify);
  };
